import React, { useState, useEffect } from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

import { injectIntl, FormattedMessage } from "gatsby-plugin-react-intl";

const Moodboard = ({intl}) => {

  // Client-side Runtime Data Fetching
  const [builderHTML, setbuilderHTML] = useState(null);
  const [accessCode, setaccessCode] = useState("testPasswort");

  fetchData();


  async function fetchData() {
    fetch(`/api/builderIO?accessCode=${accessCode}`)
    .then( async (response) => {

      // get json response here
      let responseData = await response.json();
      
      if(response.status === 200){
        setbuilderHTML(responseData);
      }
    })
    .catch((err) => {
        //console.log(err);
    })
  }

  useEffect(() => {
    if(accessCode != "") {
      fetchData()
    }
  }, []);

  return(

    <Layout>
      <SEO title={intl.formatMessage({ id: "titleMoodboard" })} lang={intl.locale} />
      <div dangerouslySetInnerHTML={{ __html: builderHTML }} className="moodboardContainer"></div>
    </Layout>

  )
}

export default injectIntl(Moodboard)